export default "__VITE_ASSET__B4ZsNzpd__"